"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TypesenseError_1 = tslib_1.__importDefault(require("./TypesenseError"));
var ObjectAlreadyExists = /** @class */ (function (_super) {
    tslib_1.__extends(ObjectAlreadyExists, _super);
    function ObjectAlreadyExists() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ObjectAlreadyExists;
}(TypesenseError_1.default));
exports.default = ObjectAlreadyExists;
//# sourceMappingURL=ObjectAlreadyExists.js.map